// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__3YKbb","List-ol":"List_List-ol__IYeaZ"};